import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography } from "@mui/material";

const FullPageLoader = ({ message }) => (
  <Box
    component="main"
    aria-busy="true"
    aria-live="polite"
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
    }}
  >
    <CircularProgress aria-label={message} />
    <Typography>{message}</Typography>
  </Box>
);

FullPageLoader.propTypes = {
  message: PropTypes.string.isRequired,
};

export default FullPageLoader;
